import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { EdiRespondeOrder, GungEdimessageType } from '../../models/edi';
import { EdiMessageBaseActionConfigService } from '../edi-message-base-action-config/edi-message-base-action-config.service';
import { ActionButtonConfigService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class EdiRespondeOrderResponseActionConfigService
  extends EdiMessageBaseActionConfigService
  implements ActionButtonConfigService<EdiRespondeOrder>
{
  protected getMessageType(): GungEdimessageType {
    return GungEdimessageType.ORDER_RESPONSE;
  }
}
